<template>
    <div class="content">
        <h1>Crie seu acesso</h1>
            <form @submit="handleSubmit">
            <!-- <input-text
                inId="name"
                inName="Nome completo"
                inType="text"
                :inRequired="true"
                v-model="form.name"
            />
            <input-text
                inId="email"
                inName="E-mail"
                inType="email"
                :inRequired="true"
                v-model="form.email"
            />
            <input-text
                inId="password"
                inName="Senha"
                inType="password"
                :inRequired="true"
                v-model="form.password"
            />
            <input-text
                inId="password_confirm"
                inName="Confirmar Senha"
                inType="password_confirm"
                :inRequired="true"
                v-model="form.password_confirmation"
            /> -->
            <div class="input-box">
                <label for="name">Nome Completo *</label>
                <input
                    type="text"
                    name="name"
                    id="name"
                    v-model="form.name" />
                <small class="error" v-if="errors && errors.name">{{errors.name.join()}}</small>
            </div>
            <div class="input-box">
                <label for="email">E-mail *</label>
                <input
                    type="text"
                    name="email"
                    id="email"
                    v-model="form.email" />
                <small class="error" v-if="errors && errors.email">{{errors.email.join()}}</small>
            </div>
            <div class="input-box">
                <label for="password">Senha *</label>
                <span class="password-icon">
                    <template>
                        <a-tooltip style="margin:0 5px;">
                            <template slot="title">
                                A senha deve ter no mínimo 6 caracteres e ser composta de, ao menos, letras e números.
                            </template>
                            <font-awesome-icon :icon="['fa', 'question-circle']"/>
                        </a-tooltip>
                    </template>
                    <font-awesome-icon @click="handleShowPassword(0)" v-if="!showPassword" :icon="['fa', 'eye-slash']" />
                    <font-awesome-icon @click="handleShowPassword(0)" v-if="showPassword" :icon="['fa', 'eye']" />
                </span>
                <input
                    type="password"
                    name="password"
                    id="password"
                    v-model="form.password" />
                <small class="error" v-if="errors && errors.password">{{errors.password.join()}}</small>
            </div>
            <div class="input-box">
                <label for="confirm_password">Confirmar Senha *</label>
                <span class="password-icon">
                    <template>
                        <a-tooltip style="margin:0 5px;">
                            <template slot="title">
                                Lembre-se, as senhas devem coincidir.
                            </template>
                            <font-awesome-icon :icon="['fa', 'question-circle']"/>
                        </a-tooltip>
                    </template>
                    <font-awesome-icon @click="handleShowPassword(1)" v-if="!showConfirmPassword" :icon="['fa', 'eye-slash']" />
                    <font-awesome-icon @click="handleShowPassword(1)" v-if="showConfirmPassword" :icon="['fa', 'eye']" />
                </span>
                <input
                    type="password"
                    name="confirm_password"
                    id="confirm_password"
                    v-model="form.password_confirmation" />
                <small class="error" v-if="errors && errors.password_confirmation">{{errors.password_confirmation.join()}}</small>
            </div>
            <div class="form-actions" v-if="!success">
                <button v-if="!loading" class="button btn-primary">
                    Cadastrar
                </button>
                <button v-if="loading" class="button btn-primary" disabled>
                    <loading />
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import { POST_USER } from '../../../services/user'

    export default {
        name: "RegisterForm",
        data() {
            return {
                showPassword: false,
                showConfirmPassword: false,
                loading: false,
                success: false,
                form: {
                    name: null,
                    email: null,
                    password: null,
                    password_confirmation: null,
                },
              formLogin: {
                  email: null,
                  password: null
              },
                errors: []
            }
        },
        methods: {
            clearErrors() {
                this.errors = [];
            },
            handleShowPassword(field) {
                if(field === 0){
                    this.showPassword = !this.showPassword;
                }else {
                    this.showConfirmPassword = !this.showConfirmPassword;
                }
                const password = field === 0 ? document.getElementById('password') : document.getElementById('confirm_password');
                if(field === 0)
                    if(this.showPassword){
                        password.type = "text";
                    }else{
                        password.type = "password";
                    }
                if(field === 1)
                    if(this.showConfirmPassword){
                        password.type = "text";
                    }else{
                        password.type = "password";
                    }
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.loading = true;
                this.clearErrors();
                try{
                    const response = await POST_USER(this.form);
                    this.formLogin.email = this.form.email;
                    this.formLogin.password = this.form.password;
                    this.$emit('next', this.formLogin);
                } catch(error) {
                    this.errors = error.response.data.errors;
                } finally {
                    this.loading = false;
                }
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RegisterModal/steps/RegisterForm.vue